import { render, staticRenderFns } from "./PartnerEdit.vue?vue&type=template&id=d0d72d40&scoped=true&"
import script from "./PartnerEdit.vue?vue&type=script&lang=js&"
export * from "./PartnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d72d40",
  null
  
)

export default component.exports